import { createClient } from '@supabase/supabase-js'

const supabaseUrl = (import.meta as any).env.VITE_SUPABASE_URL
const supabaseAnonKey = (import.meta as any).env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('⚠️ Supabase credentials not found. Please check your .env file.')
}

export const supabase = createClient(
    supabaseUrl || 'https://placeholder.supabase.co',
    supabaseAnonKey || 'placeholder-key',
    {
        auth: {
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: true,
            // Store session in localStorage for instant recovery on reload
            storage: typeof window !== 'undefined' ? window.localStorage : undefined,
            // Auto-refresh token 60s before expiry for uninterrupted sessions
            flowType: 'pkce',
        },
        // Connection pooling — reuse HTTP connections to reduce latency
        global: {
            headers: {
                'x-client-info': 'wells-wallet/1.0',
            },
        },
        // Realtime disabled by default — enable only where needed
        realtime: {
            params: {
                eventsPerSecond: 2,
            },
        },
    },
)

export { supabaseUrl, supabaseAnonKey }
